import type { Scout } from './types.ts'

import type { ExportFormat } from '@/shared/utils/export.utils'
import { exportData } from '@/shared/utils/export.utils'

export const transformScouts = (scouts: Scout[]) => {
  return scouts.map(scout => {
    const streetPart = scout.street || ''
    const cityPart = [scout.postalcode, scout.city].filter(Boolean).join(' ')
    const address = [streetPart, cityPart].filter(Boolean).join(', ')

    return {
      'First Name': scout.firstName || '-',
      'Last Name': scout.lastName || '-',
      Email: scout.email || '-',
      Phone: scout.phoneNumber || '-',
      Address: address || '-',
      'Email Verified': scout.emailVerification ? 'Yes' : 'No',
      Status: scout.status || '-',
    }
  })
}

export const exportScouts = (scouts: Scout[], format: ExportFormat = 'xlsx') => {
  const data = transformScouts(scouts)
  exportData(data, {
    filename: 'scouts',
    sheetName: 'Scouts',
    format,
  })
}
